import React, { useEffect, useRef } from 'react';
import Slide from './Slide';

/**
 * Slider - Homepage slider component with owl-carousel initialization
 * Follows React Rules: Side effects in useEffect
 * 
 * @param {Array} slides - Array of slide objects
 */
const Slider = ({ slides = [] }) => {
  const sliderRef = useRef(null);

  useEffect(() => {
    if (!slides || slides.length === 0) {
      return;
    }

    // Initialize owl-carousel after scripts are loaded
    const initCarousel = () => {
      if (window.jQuery && window.jQuery.fn.owlCarousel && sliderRef.current) {
        // Destroy existing carousel if any
        if (window.jQuery(sliderRef.current).data('owlCarousel')) {
          window.jQuery(sliderRef.current).owlCarousel('destroy');
        }
        
        // Initialize owl-carousel with link support
        window.jQuery(sliderRef.current).owlCarousel({
          loop: false,
          margin: 0,
          nav: true,
          autoplay: true,
          items: 1,
          autoplayTimeout: 10000,
          navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
          dots: true,
          autoHeight: true,
          lazyLoad: true,
          URLhashListener: false,
          mouseDrag: true,
          touchDrag: true,
          pullDrag: true,
          freeDrag: false,
          rewind: true
        });
      }
    };

    // Wait for jQuery and owl-carousel to be available
    const checkAndInit = () => {
      if (window.jQuery && window.jQuery.fn.owlCarousel) {
        // Wait a bit more for DOM to be ready
        setTimeout(initCarousel, 200);
      } else {
        // Retry after a short delay
        setTimeout(checkAndInit, 100);
      }
    };

    // Start checking after a short delay to allow scripts to load
    const timeoutId = setTimeout(checkAndInit, 500);

    // Cleanup on unmount
    return () => {
      clearTimeout(timeoutId);
      if (window.jQuery && sliderRef.current && window.jQuery(sliderRef.current).data('owlCarousel')) {
        window.jQuery(sliderRef.current).owlCarousel('destroy');
      }
    };
  }, [slides]);

  if (!slides || slides.length === 0) {
    return null;
  }

  return (
    <div className="slider-area">
      <div ref={sliderRef} className="slider-active owl-carousel" data-react-carousel="true">
        {slides.map((slide, index) => (
          <Slide key={slide.id || index} slide={slide} />
        ))}
      </div>
    </div>
  );
};

export default Slider;

